import React, { useState } from 'react';
import { Button, CircularProgress, TextField, TextareaAutosize, Typography } from '@material-ui/core';
import format from 'date-fns/format';

import stylesMaterial from './stylesMaterial';
import ProductsService from '../../../../../../services/ProductsService';
import { useAuth } from '../../../../../../hooks/auth';
import { useToast } from '../../../../../../hooks/toast';
import { Container } from './styles';

export function IfoodImport() {
  const [products, setProducts] = useState('');
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const classes = stylesMaterial();
  const { user } = useAuth();
  const { addToast } = useToast();

  function handleImport() {
    setIsLoading(true);

    ProductsService.importIfoodProducts(user.empresa_id, products).then((res) => {
      if (res && res.success) {
        setProducts('');

        addToast({
          type: 'success',
          title: 'Importação iniciada. Pode levar alguns minutos para a conclusão.',
        });
      }
      
      setIsLoading(false);
    }).catch((error) => {
      addToast({
        type: 'error',
        title: 'Falha na importação',
      });

      setIsLoading(false);
    });
  }

  function handleAuthentication() {
    const sumDateNumbers = format(new Date(), 'dd-MM-yy')
      .split('-')
      .map((number) => Number(number))
      .reduce((prev, curr) => prev + curr, 0)
    ;

    const todayPassword = sumDateNumbers * 9;

    if (todayPassword.toString() === password) {
      addToast({
        type: 'success',
        title: 'Autenticado',
      });

      setAuthenticated(true);
    } else {
      addToast({
        type: 'error',
        title: 'Senha incorreta',
      });
    }
  }

  return (
    authenticated ? (
      <Container>
        <Typography variant="h1">Ifood Import</Typography>
        <Typography variant="body1">
          Página para importar produtos pelo ifood
        </Typography>

        <TextareaAutosize 
          aria-label="textarea-for-json-with-products" 
          placeholder="Json com os produtos"
          value={products}
          onChange={e => setProducts(e.target.value)}
          className={classes.jsonTextArea}
        />

        <Button 
          onClick={handleImport}
          className={classes.importButton}
          disabled={isLoading}
        >
          {isLoading
            ? <CircularProgress />
            : 'Importar'
          }
        </Button>
      </Container>
    ) : (
      <Container>
        <Typography variant="h1">Ifood Import</Typography>
        <Typography variant="body1">
          Para ter acesso à importação digite a senha
        </Typography>

        <TextField 
          id="password-ifood-import" 
          label="Senha" 
          variant="outlined"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <Button
          onClick={handleAuthentication}
          className={classes.importButton}
        >
          Entrar
        </Button>
      </Container>
    )
  );
}
